import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Scenario } from 'store/types/types';
import { convertScenarioForLocale } from 'advanced/scenarios/util/convertScenarioForLocale';
import { getFVSSScenario } from 'advanced/scenarios/selectors';
import { getActiveScenario } from 'advanced/scenarios/scenarioSelectors';
import { getActiveCropNominalWeight } from 'current/currentSelectors';
import { getMessage } from 'util/locale';
import BaseGraph from './BaseGraph';
import FieldAverageGraphLabel from './FieldAverageGraphLabel';
import PlantingRateInputs from './PlantingRateInputs';
import { LINE_TYPES } from 'constants/advanced';
import { setActiveScenarioUuid } from 'advanced/scenarios';
import { setPlantingPlanParams } from 'planting-plan-form';

const FieldAverageGraph = () => {
  const cropNominalWeight = useSelector(getActiveCropNominalWeight);
  const activeScenario = useSelector(getActiveScenario);
  const fvssScenario: Scenario = useSelector(getFVSSScenario);
  const convertedFvssScenario = convertScenarioForLocale({ scenario: fvssScenario, cropNominalWeight });
  const fvssPlantingRate = convertedFvssScenario.avgRate.q;

  const dispatch = useDispatch();

  const setRecommendationAsActive = () => {
    dispatch(setActiveScenarioUuid(fvssScenario.scenarioUuid));
    dispatch(setPlantingPlanParams(fvssScenario.plantingPlanParams));
  };

  return (
    <section className='graph-container'>
      <header>
        <p>{getMessage('enter-desired-density-move-slider')}</p>
        <button onClick={setRecommendationAsActive}>{getMessage('set-to-recommendation')}</button>
      </header>
      <BaseGraph linesToShow={LINE_TYPES.FIELD_AVERAGE_YIELD} />
      <FieldAverageGraphLabel fvssPlantingRate={fvssPlantingRate} />
      <PlantingRateInputs key={activeScenario.scenarioUuid} />
    </section>
  );
};

export default FieldAverageGraph;
